export default __webpack_public_path__ + "static/og-nhs-80dabedf125d5626c6753878f145cde9.jpg";